import * as React from "react";
import { MenuItem, makeStyles, Box } from "@material-ui/core";
import { MUISelect, themeVariables } from "..";
import { SvgIcon } from "../../../../components";
import EyeCrossedIcon from "../../../../components/Icons/eyeCrossed";

interface IProps {
  status: "pause" | "active" | "deleted" | "blocked" | "finished";
  hide?: boolean;
  setDialog: any;
}

export const StatusSelect = (props: IProps) => {
  const { status } = props;
  const classes = makeStyles({
    field: {
      [themeVariables.breakpoints.down("sm")]: {
        paddingRight: themeVariables.spacing,
      },
    },
    eyeCrossed: {
      color: themeVariables.palette.error.main,
    }
  })({});

  return status ? (
    <Box className={classes.field}>
      <MUISelect
        variant="outlined"
        value={status}
        open={false}
        onOpen={props.setDialog}
      >
        <MenuItem value={status}>
          {props.hide && (props.status === "blocked" || props.status === "pause") 
            ? <EyeCrossedIcon className={classes.eyeCrossed} />
            : <SvgIcon type={`sl-${status}`} />
          }
        </MenuItem>
      </MUISelect>
    </Box>
  ) : null;
};
